// Structure constants
export const Gate = "Gate";
export const Line = "Line";
export const Color = "Color";
export const Tone = "Tone";
export const Base = "Base";

// Planets
export const Sun = "Sun";
export const Earth = "Earth";
export const Moon = "Moon";
export const Mercury = "Mercury";
export const Venus = "Venus";
export const Mars = "Mars";
export const Jupiter = "Jupiter";
export const Saturn = "Saturn";
export const Uranus = "Uranus";
export const Neptune = "Neptune";
export const Pluto = "Pluto";

// The Lunar Nodes
export const NorthNode = "North Node";
export const SouthNode = "South Node";

// Asteroids
export const Chiron = "Chiron";

// Signs
export const Aries = "Aries";
export const Taurus = "Taurus";
export const Gemini = "Gemini";
export const Cancer = "Cancer";
export const Leo = "Leo";
export const Virgo = "Virgo";
export const Libra = "Libra";
export const Scorpio = "Scorpio";
export const Sagittarius = "Sagittarius";
export const Capricorn = "Capricorn";
export const Aquarius = "Aquarius";
export const Pisces = "Pisces";
